var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row flex-row-wrapper"},[_c('div',{staticClass:"f-3"},[_c('p',[_vm._v(_vm._s(this.lable))])]),_c('div',{staticClass:"f-5"},[_c('p',[_vm._v(_vm._s(this.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }